const joinDiscoveryPath = (...segments) => `/discovery/${segments.join('/')}`;

// Resolve the structural parent represented by the mobile Discovery header's
// Back arrow. This intentionally models the route hierarchy instead of
// removing the final URL segment, because list roots and detail routes have
// different semantic parents.
export const getDiscoveryParentPath = (pathname) => {
    const segments = String(pathname || '')
        .split('?')[0]
        .split('#')[0]
        .split('/')
        .filter(Boolean);

    if (segments[0] !== 'discovery') return null;

    const [, section, firstId, child, secondId, leaf] = segments;

    if (section === 'companies') {
        if (segments.length <= 2 || firstId === 'jobs') return null;
        if (segments.length === 3) return joinDiscoveryPath('companies');
        if (segments.length === 4 && (child === 'jobs' || child === 'hiring')) {
            return joinDiscoveryPath('companies', firstId);
        }
        return null;
    }

    if (section === 'jobs') return null;

    if (section === 'cities') {
        if (segments.length <= 2) return null;
        if (segments.length === 3) return joinDiscoveryPath('cities');
        if (segments.length === 4) return joinDiscoveryPath('cities', firstId);

        if (segments.length === 5 && child === 'companies') {
            if (secondId === 'jobs') return joinDiscoveryPath('cities', firstId);
            return joinDiscoveryPath('cities', firstId, 'companies');
        }
        if (segments.length === 5 && child === 'jobs') {
            return joinDiscoveryPath('cities', firstId, 'jobs');
        }
        if (segments.length === 6 && child === 'companies' && (leaf === 'jobs' || leaf === 'hiring')) {
            return joinDiscoveryPath('cities', firstId, 'companies', secondId);
        }
        return null;
    }

    if (section !== 'countries') return null;
    if (segments.length <= 2) return null;
    if (segments.length === 3) return joinDiscoveryPath('countries');
    if (segments.length === 4) return joinDiscoveryPath('countries', firstId);

    if (child === 'companies') {
        if (segments.length === 5) return joinDiscoveryPath('countries', firstId, 'companies');
        if (segments.length === 6 && (leaf === 'jobs' || leaf === 'hiring')) {
            return joinDiscoveryPath('countries', firstId, 'companies', secondId);
        }
        return null;
    }

    if (child !== 'cities') return null;

    const cityId = secondId;
    const cityChild = leaf;
    const companyOrJobId = segments[6];
    const companyLeaf = segments[7];

    if (segments.length === 5) return joinDiscoveryPath('countries', firstId, 'cities');
    if (segments.length === 6) return joinDiscoveryPath('countries', firstId, 'cities', cityId);

    if (segments.length === 7 && cityChild === 'companies') {
        if (companyOrJobId === 'jobs') {
            return joinDiscoveryPath('countries', firstId, 'cities', cityId);
        }
        return joinDiscoveryPath('countries', firstId, 'cities', cityId, 'companies');
    }
    if (segments.length === 7 && cityChild === 'jobs') {
        return joinDiscoveryPath('countries', firstId, 'cities', cityId, 'jobs');
    }
    if (
        segments.length === 8 &&
        cityChild === 'companies' &&
        (companyLeaf === 'jobs' || companyLeaf === 'hiring')
    ) {
        return joinDiscoveryPath('countries', firstId, 'cities', cityId, 'companies', companyOrJobId);
    }

    return null;
};

export default getDiscoveryParentPath;
